import React from 'react';
import { bool, func, object } from 'prop-types';
import { renderRichTextReact } from '../../../utils/storyblokRichText';

function Banner(props) {
  const { data, onBannerClick, bannerClicked } = props;

  // Banner CTA clicked
  const onClickBanner = () => {
    if (!bannerClicked) {
      return onBannerClick(true);
    }
    return onBannerClick(false);
  };

  return (
    <div className="relative z-4">
      <div id="activePromoBanner" className="bg-orange-400 py-[10px]">
        <div
          className="[&_p]:typography-body-xxs sm:[&_p]:typography-body-xs lg:[&_p]:typography-body-s !text-white
            text-center px-[12.5%] md:px-[20%]"
        >
          <div className="[&>a]:inline-block [&>p]:inline">
            {renderRichTextReact(data.content.body)}
            {data.content.includeCtaButton && (
              <a
                onClick={onClickBanner}
                onKeyDown={onClickBanner}
                role="button"
                tabIndex={0}
                className="inline-block ml-[.5em]"
              >
                <p className="!font-bold">{data.content.ctaText}</p>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

Banner.propTypes = {
  onBannerClick: func,
  bannerClicked: bool,
  data: object,
};
Banner.defaultProps = {
  bannerClicked: false,
};

export default Banner;
